import { Box, Flex, Img, ListItem, Stack, Text, UnorderedList } from "@chakra-ui/react";
import Logo from "./logolight.png";
import { Link, useNavigate } from "react-router-dom";
import { socialLinks } from "../../constants/socialLinks";
import { IconWrapper, FacebookIcon, InstagramIcon, LinkedInIcon, TwitterIcon } from "../Icons";

const Footer = () => {
	const navigate = useNavigate();
	const socialIcons = [
		{ Icon: FacebookIcon, link: socialLinks.facebook },
		{ Icon: InstagramIcon, link: socialLinks.instagram },
		{ Icon: LinkedInIcon, link: socialLinks.linkedin },
		{ Icon: TwitterIcon, link: socialLinks.twitter },
	];
	return (
		<Box padding={["4rem 4rem 2rem 4rem", "6rem 6rem 2rem 6rem"]} bg="#290F44">
			<Stack direction={["column", "row"]}>
				<Box flex="1">
					<Img loading="lazy" mb={5} src={Logo} width="50%" />
					<Text maxW="400px" lineHeight="24px" color="#fff" opacity=".7">
						At Zealight Innovation Labs, we partner with your business to ensure tech is never something you have to worry about again. We provide
						both human resources and experience to help you achieve your tech goals while you focus on other aspects of your business.
					</Text>
				</Box>
				<Box flex="1">
					<Flex justifyContent="space-around">
						<UnorderedList color="#fff" lineHeight="36px" listStyleType="none">
							<ListItem fontSize="1.2rem" color="#BC88F3" mb={4}>
								Company
							</ListItem>
							<ListItem cursor="pointer" transition="250ms ease" _hover={{ color: "#BC88F3" }} onClick={() => navigate("/about")}>
								About Us
							</ListItem>
							<ListItem cursor="pointer" transition="250ms ease" _hover={{ color: "#BC88F3" }} onClick={() => navigate("/services")}>
								Services
							</ListItem>
							<ListItem cursor="pointer" transition="250ms ease" _hover={{ color: "#BC88F3" }} onClick={() => navigate("/portfolio")}>
								Portfolio
							</ListItem>
							<ListItem cursor="pointer" transition="250ms ease" _hover={{ color: "#BC88F3" }} onClick={() => navigate("/products")}>
								Products
							</ListItem>
							<ListItem cursor="pointer" transition="250ms ease" _hover={{ color: "#BC88F3" }} onClick={() => navigate("/blog")}>
								Blog
							</ListItem>
						</UnorderedList>
						<Box>
							<UnorderedList color="#fff" lineHeight="36px" listStyleType="none">
								<ListItem color="#BC88F3" fontSize="1.2rem" mb={4} onClick={() => navigate("/contact")}>
									Contact Us
								</ListItem>
								<Link to="/faqs">
									<ListItem cursor="pointer" transition="250ms ease" _hover={{ color: "#BC88F3" }} onClick={() => navigate("/faqs")}>
										FAQs
									</ListItem>
								</Link>
							</UnorderedList>
							<Box marginLeft="12px" marginTop="50px">
								<Text mb={2} color="#CFAAF6" className="bold" fontSize=".9rem">
									Feel free to get in touch with us
								</Text>
								<a href="mailto:info@zealightlabs.com" target="_blank" rel="noopener noreferrer">
									<Text color="#fff">info@zealightlabs.com</Text>
								</a>
								<IconWrapper mt={5} gap="2rem">
									{socialIcons.map(({ Icon, link }) => (
										<a key={link} href={link} target="_blank" rel="noopener noreferrer">
											<IconWrapper cursor="pointer" transition="250ms ease" _hover={{ transform: "scale(.8)" }} color="#fff" fontSize="2rem">
												<Icon />
											</IconWrapper>
										</a>
									))}
								</IconWrapper>
							</Box>
						</Box>
					</Flex>
				</Box>
			</Stack>
			<Text marginTop="50px" color="#fff">
				Copyright © 2026. All Rights Reserved.
			</Text>
		</Box>
	);
};

export default Footer;
